import { useState } from 'react';
import { Link } from 'react-router-dom';
import LogoImage from '../ui/LogoImage';

function FooterLogo() {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <svg width="48" height="48" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="48" fill="#1a1a6e" stroke="#1eb5e8" strokeWidth="3" />
        <path d="M50 18 A32 32 0 1 1 50 82 A22 22 0 1 0 50 18Z" fill="#1eb5e8" />
        <polygon points="50,24 53,34 63,34 55,40 58,51 50,45 42,51 45,40 37,34 47,34" fill="#1eb5e8" stroke="#1a1a6e" strokeWidth="1" />
      </svg>
    );
  }
  return (
    <img src="/logo.png" alt="JNF" className="h-12 w-12 rounded-full border-2 border-cyan-400 object-cover"
      onError={() => setFailed(true)} />
  );
}

export default function Footer() {
  return (
    <footer className="bg-navy-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <FooterLogo />
              <div>
                <p className="font-bold text-lg">Jamuiyat Nasir Al-Fridaous Al Tijaniyyah</p>
                <p className="text-cyan-400 text-sm">Kafa Billahi Waliyan Wakafa Billahi Nasiran</p>
              </div>
            </div>
            <p className="arabic text-xl text-cyan-300 mb-2">كفى بالله وليا وكفى بالله نصيرا</p>
            <p className="text-white/60 text-sm leading-relaxed">
              A Tijaniyyah Sufi JAMA dedicated to the remembrance of Allah,
              following the path of Shaykh Ahmad Tijani (R.A).
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-cyan-400 mb-4 uppercase text-xs tracking-wider">Quick Links</h3>
            <ul className="space-y-2 text-sm text-white/70">
              {[
                ['/', 'Home'],
                ['/events', 'Events'],
                ['/gallery', 'Gallery'],
                ['/radio', 'Radio Stations'],
                ['/sawia', 'Sawia Locations'],
                ['/contact', 'Contact Us'],
                ['/about', 'About Us'],
                ['/member/register', 'Join JNF'],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="hover:text-cyan-400 transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-cyan-400 mb-4 uppercase text-xs tracking-wider">Contact</h3>
            <ul className="space-y-2 text-sm text-white/70">
              <li>📧 majilisfirdaous@gmail.com</li>
              <li>🌐 www.jnfridaoux.com</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-white/40 text-sm">© {new Date().getFullYear()} JNF. All rights reserved.</p>
          <Link to="/admin/login" className="text-white/30 hover:text-white/60 transition-colors text-xs">
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
